/* Wolki Farm — Meat Box PDP interactive layer. */
(function () {
  "use strict";
  var root = document.querySelector(".mb-page");
  if (!root) return;

  var dataEl = document.getElementById("mb-data");
  var data = {};
  try { data = JSON.parse(dataEl.textContent); } catch (e) {}

  var AUD = function (n) {
    var rounded = Math.round(n * 100) / 100;
    return "$" + rounded.toLocaleString("en-AU", {
      minimumFractionDigits: rounded % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
  };

  var state = {
    variantId: data.defaultVariantId,
    variantPrice: data.defaultPrice || 0,
    subscribe: false,
    addons: 0,
    selectedAddons: [],
  };

  var sizeBtns = root.querySelectorAll("[data-mb-size]");
  var purchaseBtns = root.querySelectorAll("[data-mb-purchase]");
  var addonInputs = root.querySelectorAll("[data-mb-addon]");
  var totalOut = root.querySelectorAll("[data-mb-out='total']");
  var ctaTotalOut = root.querySelectorAll("[data-mb-out='cta-total']");
  var afterpayOut = root.querySelectorAll("[data-mb-out='afterpay']");
  var buyBtns = root.querySelectorAll("[data-mb-addtocart]");
  var stickyEl = root.querySelector("[data-mb-sticky-cta]");
  /* Sticky cart bar reveals once the hero scrolls offscreen, not the buy box —
     gets a persistent ATC in front of the user earlier on the page. */
  var sentinelEl = root.querySelector(".mb-hero") || root.querySelector("[data-mb-buybox]");
  var topBtn = root.querySelector("[data-mb-totop]");

  /* 2026-10-09: show the price under each size button (markup has kg only). */
  sizeBtns.forEach(function (btn) {
    if (btn.querySelector(".mb-pk")) return;
    var p = parseFloat(btn.getAttribute("data-mb-price"));
    if (!p) return;
    var pk = document.createElement("span");
    pk.className = "mb-pk";
    pk.textContent = AUD(p);
    btn.appendChild(pk);
  });

  /* 2026-10-09: "From $X · ★ 4.9 from verified reviews" pill in the hero so the
     price is visible on the first screen (mobile especially). */
  (function () {
    var heroWrap = root.querySelector(".mb-hero__copy .mb-wrap");
    var h1 = heroWrap && heroWrap.querySelector("h1");
    if (!h1 || heroWrap.querySelector(".mb-hero__from")) return;
    var prices = (data.variants || []).map(function (v) { return parseFloat(v.price); }).filter(function (n) { return n > 0; });
    if (!prices.length) return;
    var min = Math.min.apply(null, prices);
    var ratingEl = root.querySelector(".mb-buy__reviews .mb-agg .mb-n");
    var summaryEl = root.querySelector(".mb-buy__reviews .mb-agg small");
    var pill = document.createElement("div");
    pill.className = "mb-hero__from";
    var html = "<span class=\"mb-hero__from-price\">From " + AUD(min) + "</span>";
    if (ratingEl) {
      html += "<span class=\"mb-hero__from-sep\" aria-hidden=\"true\">·</span>" +
        "<span class=\"mb-hero__from-stars\"><span class=\"mb-s\">★</span> " + ratingEl.textContent.trim() +
        (summaryEl ? " " + summaryEl.textContent.trim() : "") + "</span>";
    }
    pill.innerHTML = html;
    var after = heroWrap.querySelector(".mb-hero__stars") || h1;
    after.insertAdjacentElement("afterend", pill);
  })();

  function render() {
    var total = state.variantPrice + state.addons;
    totalOut.forEach(function (el) { el.textContent = AUD(total); });
    ctaTotalOut.forEach(function (el) { el.textContent = AUD(total); });
    afterpayOut.forEach(function (el) { el.textContent = AUD(total / 4); });
  }

  var backorderEl = root.querySelector("[data-mb-backorder-note]");
  sizeBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      sizeBtns.forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
      btn.setAttribute("aria-pressed", "true");
      state.variantId = btn.getAttribute("data-mb-variant-id");
      state.variantPrice = parseFloat(btn.getAttribute("data-mb-price")) || 0;
      if (backorderEl) {
        var isBackorder = btn.getAttribute("data-mb-backorder") === "true";
        if (isBackorder) backorderEl.removeAttribute("hidden");
        else backorderEl.setAttribute("hidden", "");
      }
      render();
    });
  });

  purchaseBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      purchaseBtns.forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
      btn.setAttribute("aria-pressed", "true");
      state.subscribe = btn.getAttribute("data-mb-purchase") === "subscribe";
      render();
    });
  });

  addonInputs.forEach(function (cb) {
    cb.addEventListener("change", function () {
      state.addons = 0;
      state.selectedAddons = [];
      addonInputs.forEach(function (other) {
        if (other.checked) {
          var p = parseFloat(other.getAttribute("data-mb-addon-price")) || 0;
          state.addons += p;
          var vid = other.getAttribute("data-mb-addon-variant");
          if (vid) state.selectedAddons.push(vid);
        }
      });
      render();
    });
  });

  buyBtns.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (!state.variantId) return;
      var items = [{ id: parseInt(state.variantId, 10), quantity: 1 }];
      if (state.subscribe && data.subscribeSellingPlanId) {
        items[0].selling_plan = parseInt(data.subscribeSellingPlanId, 10);
      }
      state.selectedAddons.forEach(function (vid) {
        items.push({ id: parseInt(vid, 10), quantity: 1 });
      });
      var orig = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: items }),
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      }).then(function () {
        window.location.href = "/cart";
      }).catch(function () {
        btn.disabled = false;
        btn.innerHTML = orig;
        alert("Sorry, couldn't add to cart. Please refresh and try again.");
      });
    });
  });

  if (stickyEl && sentinelEl) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var leftView = e.boundingClientRect.top < 0 && !e.isIntersecting;
        stickyEl.classList.toggle("is-visible", leftView);
      });
    }, { threshold: [0, 1] });
    io.observe(sentinelEl);
    document.body.classList.add("mb-has-sticky");
  }

  /* Back-to-top button */
  if (topBtn) {
    topBtn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    var revealAt = 400;
    var onScroll = function () {
      topBtn.classList.toggle("is-visible", window.scrollY > revealAt);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  var rio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("mb-in"); rio.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  root.querySelectorAll("[data-mb-reveal]").forEach(function (el) { rio.observe(el); });

  render();
  window.MeatBoxPDP = { state: state, render: render };
})();
